import { apiV1 } from "@/store";

const state = {
  dispositionsData: []
};

const actions = {
  retrieveSelectedAgentDispositions: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      apiV1.get(`calls`, {
        params: params
      })
        .then((resp) => {
          commit("setSelectedAgentDispositions", resp.data);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  updateDispositionAndCallType: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      let dispId = {
        disposition_id: payload.disposition_id
      };
      apiV1.patch(`calls/${payload.id}/update-disposition`, dispId)
        .then((resp) => {
          dispatch("handleSuccess", "Disposition & call type updated! Press Update to refresh the table.");
          resolve(resp);
        })
        .catch((err) => {
          dispatch("handleError", err);
          reject(err);
        });
    });
  },

  clearSelectedAgentDispositions: ({ commit }) => {
    commit("resetAgentDispositions");
  }
};

const mutations = {
  setSelectedAgentDispositions: (state, dispositions) => {
    state.dispositionsData = dispositions;
  },

  resetAgentDispositions: (state) => {
    state.dispositionsData = [];
  }
};

const getters = {
  agentDispositions: state => {
    return state.dispositionsData.calls;
  }
};
export default {
  state,
  actions,
  mutations,
  getters
};
